import React from "react";
import "@/App.css";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import MivanTech from "@/components/site/MivanTech";
import Projects from "@/components/site/Projects";
import Legacy from "@/components/site/Legacy";
import Sustainability from "@/components/site/Sustainability";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-ink-900 text-white selection:bg-gold selection:text-ink-900">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <MivanTech />
        <Projects />
        <Legacy />
        <Sustainability />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
